module.exports = __webpack_public_path__ + "img/prize-frame.85cac9e1.webp";